<template>
  <div class="col-md-12">
    <Form @submit="handleForm">
      <div>
        <Header></Header>
        <div class="header-group">
          <h1><img src="@/assets/img/underline.png">{{ this.title }}</h1>
        </div>

        <div class="form-group">
          <label class="candidature-condition-text">Ancienne adresse email:</label>
          <Field v-model="emailFrom" class="form-control" name="emailFrom" readonly type="text"/>
        </div>
        <div class="form-group">
          <label class="candidature-condition-text">Nouvelle adresse email:</label>
          <Field v-model="emailTo" class="form-control" name="emailTo" readonly type="text"/>
        </div>

        <div class="form-group">
          <button class="btn btn-primary btn-block">
            <span v-show="loading" class="spinner-border spinner-border-sm"></span>
            {{ this.btnLabel }}
          </button>
        </div>
      </div>
    </Form>

    <div
        v-if="message"
        :class="successful ? 'alert-success' : 'alert-danger'"
        class="alert"
    >
      {{ message }}
    </div>
  </div>
</template>

<script>
import {ErrorMessage, Field, Form} from "vee-validate";

import Header from '@/views/public/newAccount/Header.vue';
import UserApi from "@/api/UserApi";
import RouteEnum from "@/router/RouteEnum";

export default {
  name: "RegenerateEmail",
  components: {
    Form,
    Field,
    ErrorMessage,
    Header
  },
  data() {
    return {
      loading: false,
      message: null,
      successful: false,
      token: '',
      emailFrom: '',
      emailTo: '',
      title: 'NOUVELLE ADRESSE EMAIL',
      btnLabel: 'Je confirme le changement d\'adresse'
    };
  },

  mounted() {
    this.token = this.$route.params.token;
    this.emailFrom = this.$route.params.emailFrom
    this.emailTo = this.$route.params.emailTo;


    if ('' === this.token) {
      this.title = 'NOUVELLE ADRESSE EMAIL DETECTÉE';
      this.btnLabel = 'J\'accepte le changement d\'adresse'
    }

    localStorage.removeItem('emailOnLogin');

  },
  methods: {
    handleForm(form) {
      this.loading = true

      this.message = "Votre demande a été prise en compte, vous allez être déconnecté, merci de vous reconnecter avec votre nouvelle adresse."
      this.successful = true
      let _ = this;
      let onSuccess = function () {
        _.successful = true

        setTimeout(function (router) {
          _.$store.dispatch('auth/logout');
          router.push({name: RouteEnum.LOGIN});
        }, 4000, _.$router)
      }

      if ('' !== this.token) {
        UserApi.confirmChangeEmail(this.token, this.emailFrom, this.emailTo).then(
            (response) => {
              onSuccess();
            },
            (error) => {
              _.message =
                  (error.response &&
                      error.response.data &&
                      error.response.data.message) ||
                  error.message ||
                  error.toString();
              _.successful = false
              _.loading = false
            }
        );
      } else {
        onSuccess();
      }
    },
  }
};
</script>
